import { createSelector } from '@reduxjs/toolkit';

import { RootState } from '..';

const settingsStateDomain = (state: RootState) => state.settings;

export const loadingSelector = createSelector(settingsStateDomain, (settings) => settings.loading);

export const settingsSelector = createSelector(settingsStateDomain, (settings) => settings);
